"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardMain = void 0;
const react_1 = __importStar(require("react"));
const Overlay_1 = require("../../../Overlay");
const PageWizardMain_styles_1 = require("./PageWizardMain.styles");
const PageWizardPanelContainerContext_1 = require("../../context/PageWizardPanelContainerContext");
const PageWizardPanelContext_1 = require("../../context/PageWizardPanelContext");
const PageWizardBody_1 = require("../../PageWizardBody/PageWizardBody");
const PageWizardFooter_1 = require("../../PageWizardFooter");
const StackView_1 = require("../../../StackView");
const WizardPanelContainer_1 = require("../../../WizardPanelContainer");
function PanelContainer({ panel, panelMinWidth, panelWidth, shrinkPanel }) {
    var _a, _b, _c;
    const panelApi = (0, react_1.useContext)(PageWizardPanelContext_1.PageWizardPanelContext);
    panel = panel || panelApi.element;
    panelMinWidth = (_b = (_a = panelApi.minWidth) !== null && _a !== void 0 ? _a : panelApi.width) !== null && _b !== void 0 ? _b : panelMinWidth;
    panelWidth = (_c = panelApi.width) !== null && _c !== void 0 ? _c : panelWidth;
    if (!panel) {
        return null;
    }
    return (react_1.default.createElement(Overlay_1.Overlay, { view: Overlay_1.OVERLAY_VIEW.tone, contentMod: Overlay_1.OVERLAY_CONTENT_MOD.right },
        react_1.default.createElement(WizardPanelContainer_1.WizardPanelContainer, { panel: panel, panelMinWidth: panelMinWidth, panelWidth: panelWidth, shrinkPanel: shrinkPanel || panelApi.isShrink })));
}
exports.PageWizardMain = (0, react_1.memo)(({ tabs, content, footer, loading, panel, panelMinWidth = '768px', panelWidth = '50%', shrinkPanel = false, pending, fullWidthContent = false, widthContent = '800px', hideTabs = false }) => {
    const containerRef = (0, react_1.useContext)(PageWizardPanelContainerContext_1.PageWizardPanelContainerContext);
    return (react_1.default.createElement(PageWizardMain_styles_1.StyledPageWizardMain, { ref: containerRef },
        react_1.default.createElement(PageWizardMain_styles_1.StyledPageWizardMainBodyWrapper, null,
            !hideTabs && (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, distribution: StackView_1.STACK_DISTRIBUTION.firstFill },
                tabs,
                !fullWidthContent && react_1.default.createElement(PageWizardMain_styles_1.StyledPageWizardMainFooter, null))),
            react_1.default.createElement(PageWizardMain_styles_1.StyledPageWizardMainBody, { direction: StackView_1.STACK_DIRECTION.column },
                react_1.default.createElement(PageWizardBody_1.PageWizardBody, { widthContent: widthContent, fullWidthContent: fullWidthContent, content: content }),
                !fullWidthContent && (react_1.default.createElement(PageWizardMain_styles_1.StyledPageWizardMainFooter, null,
                    react_1.default.createElement(PageWizardFooter_1.PageWizardFooter, { widthContent: widthContent, fullWidthContent: fullWidthContent }, footer)))),
            (loading || pending) && (react_1.default.createElement(PageWizardMain_styles_1.StyledPageWizardMainProgress, { fullHeight: !!fullWidthContent, block: loading }))),
        fullWidthContent && (react_1.default.createElement(PageWizardFooter_1.PageWizardFooter, { widthContent: widthContent, fullWidthContent: fullWidthContent }, footer)),
        react_1.default.createElement(PanelContainer, { panel: panel, panelMinWidth: panelMinWidth, panelWidth: panelWidth, shrinkPanel: shrinkPanel })));
});
//# sourceMappingURL=PageWizardMain.js.map